const CURRENCY_SYMBOL: Record<string, string> = {
  USD: '$',
  RUB: '₽',
  UZS: 'сум',
};

export function formatMoney(amount: number, currency = 'USD'): string {
  const formatted = amount.toLocaleString('ru-RU');
  const symbol = CURRENCY_SYMBOL[currency] ?? currency;
  return currency === 'USD' ? `${symbol}${formatted}` : `${formatted} ${symbol}`;
}

export function formatNumber(n: number): string {
  return n.toLocaleString('ru-RU');
}
